import React from 'react'
import Home from '../Component/Home'

const Homme = () => {
  return (
    <div>
      <Home/>
    </div>
  )
}

export default Homme
